import styled from '@emotion/styled';
import { useTranslations } from 'use-intl';

import { formatTime } from './ui.video-player.helpers';
import { Breakpoint } from './ui.video-player.types';

interface BreakpointMarkerProps {
  breakpoint: Breakpoint;
  position: number;
  size: number;
  isInHighlight?: boolean;
}

const DotContainer = styled.div<{ position: number; size: number }>`
  left: ${(props) => props.position}%;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  transform: translateZ(0);
`;

const DotShape = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
`;

export const BreakpointMarker = ({
  breakpoint,
  position,
  size,
}: BreakpointMarkerProps) => {
  const t = useTranslations('VideoPlayer.breakpoint');

  return (
    <DotContainer
      data-test='breakpoint-marker'
      data-variant='dot'
      className='absolute top-[45%] z-10 transform will-change-transform'
      position={position}
      size={size}
      title={
        breakpoint.label || t('title', { time: formatTime(breakpoint.time) })
      }
      aria-label={t('aria', {
        time: breakpoint.label || formatTime(breakpoint.time),
      })}
    >
      <DotShape
        className='size-full rounded-full bg-white transition-opacity duration-200'
        color={breakpoint.color || '#ffffff'}
      />
    </DotContainer>
  );
};
